/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPaymentGateways } from 'app/entities/payment-gateway/payment-gateway.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './tenant-payment-gateway.reducer';

export const TenantPaymentGatewayUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const paymentGateways = useAppSelector(state => state.paymentGateway.entities);
  const tenantPaymentGatewayEntity = useAppSelector(state => state.tenantPaymentGateway.entity);
  const loading = useAppSelector(state => state.tenantPaymentGateway.loading);
  const updating = useAppSelector(state => state.tenantPaymentGateway.updating);
  const updateSuccess = useAppSelector(state => state.tenantPaymentGateway.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/tenant-payment-gateway${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPaymentGateways({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.apiVersion !== undefined && typeof values.apiVersion !== 'number') {
      values.apiVersion = Number(values.apiVersion);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tenantPaymentGatewayEntity,
      ...values,
      gateway: paymentGateways.find(it => it.id.toString() === values.gateway?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...tenantPaymentGatewayEntity,
          gateway: tenantPaymentGatewayEntity?.gateway?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tenantPaymentGateway.home.createOrEditLabel" data-cy="TenantPaymentGatewayCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.home.createOrEditLabel">
              Create or edit a TenantPaymentGateway
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-payment-gateway-id"
                  label={translate('tinyMedicRestApp.tenantPaymentGateway.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.merchantId')}
                id="tenant-payment-gateway-merchantId"
                name="merchantId"
                data-cy="merchantId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="merchantIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.merchantId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.merchantKey')}
                id="tenant-payment-gateway-merchantKey"
                name="merchantKey"
                data-cy="merchantKey"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="merchantKeyLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.merchantKey" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.merchantKeyIndex')}
                id="tenant-payment-gateway-merchantKeyIndex"
                name="merchantKeyIndex"
                data-cy="merchantKeyIndex"
                type="text"
              />
              <UncontrolledTooltip target="merchantKeyIndexLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.merchantKeyIndex" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.apiVersion')}
                id="tenant-payment-gateway-apiVersion"
                name="apiVersion"
                data-cy="apiVersion"
                type="text"
              />
              <UncontrolledTooltip target="apiVersionLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.apiVersion" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.active')}
                id="tenant-payment-gateway-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.draft')}
                id="tenant-payment-gateway-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="draftLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.draft" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.cursor')}
                id="tenant-payment-gateway-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.lastUpdated')}
                id="tenant-payment-gateway-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.microSec')}
                id="tenant-payment-gateway-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.timestampEntry')}
                id="tenant-payment-gateway-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.addedById')}
                id="tenant-payment-gateway-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <UncontrolledTooltip target="addedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.addedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.modifiedById')}
                id="tenant-payment-gateway-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <UncontrolledTooltip target="modifiedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.modifiedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.addedByType')}
                id="tenant-payment-gateway-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="addedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.addedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.modifiedByType')}
                id="tenant-payment-gateway-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="modifiedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.modifiedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantPaymentGateway.tenantId')}
                id="tenant-payment-gateway-tenantId"
                name="tenantId"
                data-cy="tenantId"
                type="text"
              />
              <UncontrolledTooltip target="tenantIdLabel">
                <Translate contentKey="tinyMedicRestApp.tenantPaymentGateway.help.tenantId" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tenant-payment-gateway-gateway"
                name="gateway"
                data-cy="gateway"
                label={translate('tinyMedicRestApp.tenantPaymentGateway.gateway')}
                type="select"
              >
                <option value="" key="0" />
                {paymentGateways
                  ? paymentGateways.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tenant-payment-gateway" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantPaymentGatewayUpdate;
